module.exports = __webpack_public_path__ + "static/assets/795573a9d2fee5058a63cf5ec067fa3e.png";